'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  position: fixed;
  bottom: 0.5rem;
  display: grid;
  row-gap: 0.5rem;
  width: 90%;
  left: 50%;
  transform: translateX(-50%);
  grid-template-columns: clamp(100px, 20dvw, 140px) 1fr;
  grid-template-areas:
    'image description'
    'image download';
  z-index: 80;
  @media screen and (width > ${theme.sizes.screens.md}) {
    display: none !important;
  }
`;

export const image = css`
  grid-area: image;
  position: relative;
  img {
    position: absolute;
    bottom: -0.25rem;
    // image has way to much empty space around
    left: -10px;
  }
`;

export const description = css`
  grid-area: description;
  color: ${theme.colors.peoople['gris-oscuro-2']};
  font-weight: 500;
  line-height: 1em;
  padding-right: 0.5rem;
`;

export const download = css`
  grid-area: download;
`;

export const closeBtn = css`
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.peoople['gris-medio-claro']};
`;
